import request from "../_helpers/request";

export const sourcingTrendService = {
  LoadAllContents,
  LoadContentsById,
  AddNewContent,
  UpdateContent,
  UpdateFilePath,
  DeleteContentById,
  GetOrderOptionsByReportType,
  DuplicateContentById,
};

async function LoadAllContents() {
  return await request({
    url: "SourcingTrend/GetAllContents",
    method: "post",
  });
}

async function LoadContentsById(RID) {
  return await request({
    url: "SourcingTrend/GetContentById",
    method: "post",
    params: { RID: RID },
  });
}

/**
 * Sends a POST request to the "SourcingTrend/AddNewContent" endpoint with the provided parameters.
 *
 * @param {Object} params - The parameters to be sent in the request.
 * @param {"Sourcing_Trend" | "Market_Analysis"} params.ReportType - The report type. ("Sourcing_Trend" | "Market_Analysis")
 * @param {"unpublish"} params.Status - The status of the content, but unpublish will be used for now. ("deleted" | "unpublish" | "publish")
 * @param {string} params.Title_EN - The title of the content in English.
 * @param {string} params.Title_TC - The title of the content in Traditional Chinese.
 * @param {string} params.Title_SC - The title of the content in Simplified Chinese.
 * @param {Date} [params.EffectiveFrom] - The effective from date.
 * @param {Date} [params.EffectiveTo] - The effective to date.
 * @param {string} params.ImagePath_EN - The cdn link of the image in English.
 * @param {string} params.ImagePath_TC - The cdn link of the image in Traditional Chinese.
 * @param {string} params.ImagePath_SC - The cdn link of the image in Simplified Chinese.
 * @param {"PDF" | "URL"} params.RedirectType - The redirect type. ("PDF" | "URL")
 * @param {string} params.UrlLink_EN - The URL link in English.
 * @param {string} params.UrlLink_TC - The URL link in Traditional Chinese.
 * @param {string} params.UrlLink_SC - The URL link in Simplified Chinese.
 * @return {Promise} A promise that resolves with the response from the server.
 */
async function AddNewContent(params) {
  return await request
    .post("SourcingTrend/AddNewContent", params)
    .then((res) => {
      return res;
    });
}

/**
 * Sends a POST request to the "SourcingTrend/UpdateContent" endpoint with the provided parameters.
 *
 * @param {Object} params - The parameters to be sent in the request.
 * @param {number} params.RID - The content RID.
 * @param {"unpublish" | "publish"} params.Status - The status of the content. ("deleted" | "unpublish" | "publish")
 * @param {string} params.Title_EN - The title of the content in English.
 * @param {string} params.Title_TC - The title of the content in Traditional Chinese.
 * @param {string} params.Title_SC - The title of the content in Simplified Chinese.
 * @param {Date} [params.EffectiveFrom] - The effective from date.
 * @param {Date} [params.EffectiveTo] - The effective to date.
 * @param {string} params.ImagePath_EN - The cdn link of the image in English.
 * @param {string} params.ImagePath_TC - The cdn link of the image in Traditional Chinese.
 * @param {string} params.ImagePath_SC - The cdn link of the image in Simplified Chinese.
 * @param {"URL" | "PDF"} [params.RedirectType] - The redirect type. ("URL" | "PDF")
 * @param {string} [params.UrlLink_EN] - The URL link in English.
 * @param {string} [params.UrlLink_TC] - The URL link in Traditional Chinese.
 * @param {string} [params.UrlLink_SC] - The URL link in Simplified Chinese.
 * @param {number} [params.OrderId] - The order ID.
 * @return {Promise} A promise that resolves with the response from the server.
 */
async function UpdateContent(params) {
  return await request
    .post("SourcingTrend/UpdateContent", params)
    .then((res) => {
      return res;
    });
}

/**
 * Sends a POST request to the "SourcingTrend/UpdateFilePath" endpoint with the provided parameters.
 *
 * @param {Object} params - The parameters to be sent in the request.
 * @param {number} params.RID - The content RID.
 * @param {"ImagePath_EN" | "ImagePath_TC" | "ImagePath_SC" | "UrlLink_EN" | "UrlLink_TC" | "UrlLink_SC"} params.ColumnKey - The column key. ("ImagePath_EN" || "ImagePath_TC" || "ImagePath_SC" || "UrlLink_EN" || "UrlLink_TC" || "UrlLink_SC")
 * @param {string} params.FilePath - The CDN link of the file.
 * @return {Promise} A promise that resolves with the response from the server.
 */
async function UpdateFilePath(params) {
  return await request
    .post("SourcingTrend/UpdateFilePath", params)
    .then((res) => {
      return res;
    });
}

async function DeleteContentById(RID) {
  return await request({
    url: "SourcingTrend/DeleteContentById",
    method: "post",
    params: { RID: RID },
  });
}

/**
 * Sends a POST request to the "SourcingTrend/GetOrderOptionsByReportType" endpoint with the provided reportType.
 *
 * @param {"Sourcing_Trend" | "Market_Analysis"} reportType - The report type. ("Sourcing_Trend" | "Market_Analysis")
 * @return {Promise} A promise that resolves with the response from the server.
 */
async function GetOrderOptionsByReportType(reportType) {
  return await request({
    url: "SourcingTrend/GetOrderOptionsByReportType",
    method: "post",
    params: { reportType: reportType },
  });
}

async function DuplicateContentById(RID) {
  return await request({
    url: "SourcingTrend/DuplicateContentById",
    method: "post",
    params: { RID: RID },
  });
}
